/** basic.collectFloorManage */
export default {
    floor_numPla: "Поиск по номеру этажа",
    floor_cancelCollectTips: "Отменить избранное для этого этажа?",
    floor_uncollect: "Убрать из избранного",
    floor_dialogTitle: "Детали нового устройства",
    floor_createdTimePla: "Введите время создания",
    floot_floorNum: "",
    floor_siteNamePla: "Выберите объект",
    floor_siteAddrPla: "Адрес объекта",
    message_uncollectSucc: "Этаж убран из избранного!",
    message_uncollectLose: "Не удалось убрать этаж из избранного!",
    message_floorNoSpeac: "Этаж не может быть пустым!",
}

